export const CHEMICAL_DB_API_HOST = import.meta.env.VITE_CHEMICAL_DB_API_BASE_URL;

export const APPLICATIONS_API = '/api/applications';

export const MIX_PATH = 'mix';

export const CHEMICALS_SEED_PATH = 'chemicals/seed-from-mix';

export const JSON_HEADERS = { 'Content-Type': 'application/json' };

export const NOT_FOUND_STATUS = '404';
